/* global ace, base, doc */

/**
* jsPDFEditor
*/

import { $/*, $$, clearElementRefs*/ } from './components/_queryselector.js';
import * as _ from './components/_helpers.js';
import * as Dropdown from './components/_dropdown.js';

const jsPDFEditor = (function () {
    let editor;
    // let source;
    let loadedFile;

    const aceEditor = () => {
        editor = ace.edit('editor');
        editor.getSession().setMode('ace/mode/javascript');
        editor.setOptions({
            fontFamily: 'Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace',
            fontSize: '14px',
        });
        editor.container.style.lineHeight = 2;

        // Disable errors about semicolons
        editor.session.on('changeMode', (e, session) => {
            if (session.getMode().$id === 'ace/mode/javascript') {
                //if (!!session.$worker) {
                if (session.$worker) {
                    session.$worker.send('setOptions', [{
                        'asi': true,
                    }]);
                }
            }
        });

        let timeout = setTimeout(() => { }, 0);
        editor.getSession().on('change', () => {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                jsPDFEditor.update();
            }, 200);
        });
    };

    const loadSelectedFile = (selected) => {
        loadedFile = selected;

        _.get(`${base}parallax-2016/jspdf-examples/${selected}`, data => {
            editor.setValue(data);
            editor.gotoLine(0);
        });
    };

    const initDownloadPDF = () => {
        $('.js--jspdf-download').addEventListener('click', () => {
            eval(editor.getValue());
            doc.save(loadedFile.replace('.js', '.pdf'));
        });
        return false;
    };

    return {
        /**
        * Start the editor demo
        * @return {void}
        */
        init: () => {
            // Convert native dropdowns to non-native, nice looking, accessible ones
            Dropdown.init(document.querySelector('.js-dropdown'), el => {
                if (el.getAttribute('data-value')) {
                    loadSelectedFile(el.getAttribute('data-value'));
                } else {
                    loadSelectedFile('images.js');
                }
            });
            loadSelectedFile('images.js');

            // Init the ACE editor
            aceEditor();

            // Do the first update on init
            jsPDFEditor.update();

            initDownloadPDF();
        },
        /**
        * Update the iframe with current PDF.
        *
        * @return
        */
        update: function () {
            setTimeout(function () {

                // This hack takes it out of strict mode
                // and gives the JS the same context as the site
                const evalInContext = eval;
                evalInContext(editor.getValue(), this);

                if (typeof doc !== 'undefined') {
                    doc.setPr;
                    const string = doc.output('datauristring');
                    $('.preview-pane').setAttribute('src', string);
                }
            }, 100);
        },
    };
}());

export default jsPDFEditor;



// WEBPACK FOOTER //
// ./assets/js/jspdf-example.js